
import React, { useEffect, useState } from 'react';

import { useTranslation } from "react-i18next";


const LanguageSelector = () => {

  const { t, i18n } = useTranslation();


  const changeLanguage = (event) => {

    i18n.changeLanguage(event.target.value);

    //mylan = event.target.value
  };

  //var lan = "en"
  const [mylan, setMylan] = useState("en");
   useEffect(() => {
    

   })

   const lngs = { // 2. 언어 구분을 위한 lng 객체 생성
    en: { nativeName: 'English' },
      ko: { nativeName: "대한민국" },
  };
  
  return (

    <div  style={{marginLeft:20 }} onChange={changeLanguage}>
        
        {/* {Object.keys(lngs).map((lng) => (
            <input type="radio" value={lng} name="language"  checked={{ checked : i18n.resolvedLanguage === lng? 'true' : 'false' }}> 
            </input>
            

          ))} */}
          
          <input type="radio" value="en" name="language"  checked = {  i18n.resolvedLanguage == "en"  }/> English
      <input style={{marginLeft:20 }} type="radio" value="ko" name="language" checked = {  i18n.resolvedLanguage == "ko"  } /> 대한민국

          


      {/* <input type="radio" value="en" name="language" checked ={mylan == "en" ?"true":"false" }/> English
      <input type="radio" value="kor" name="language" checked ={mylan != "en" ?"true":"false" }/> 대한민국 */}

    </div>

  );

};


export default LanguageSelector;